

















































































































































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import VLazyImage from 'v-lazy-image';
import {mapGetters, mapActions} from 'vuex';

@Component({
  name: 'ApartmentTile',
  components: {
    VLazyImage,
  },
  props: {
    apartmentData: {
      type: Object,
      default: () => {},
    },
    apartmentTitle: {
      type: String,
      default: '',
    },
    btnTexts: {
      type: Object,
      default: () => {},
    },
    apartmentStatus: {
      type: String,
      default: '',
    },
    apartmentStatusText: {
      type: String,
      default: '',
    },
    apartmentParams: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('accounts', ['globalPermissions']),
    srcImg: {
      get() {
        return this.apartmentData.cover && `${this.apartmentData.cover[3600]}` || '';
      },
    },

    srcImgPlaceholder: {
      get() {
        return this.apartmentData.cover && `${this.apartmentData.cover[400]}`;
      },
    },

    srcSet: {
      get() {
        return this.apartmentData.cover &&
            `${this.apartmentData.cover[400]} 400w,
             ${this.apartmentData.cover[800]} 800w,
             ${this.apartmentData.cover[1300]} 1300w,
             ${this.apartmentData.cover[1900]} 1900w,
             ${this.apartmentData.cover[3600]} 3600w`;
      },
    },
  },
  methods: {
    ...mapActions(['showCentralAlert']),
    ...mapActions('profile', ['toggleFavorite', 'addStepNumber', 'cancelRentAd']),
    changePinApartment(status, id) {
      this.toggleFavorite({status, id}).then((response) => this.$emit('changeList'))
          .catch((error) => console.error(error));
    },
    createRentAdRequest() {
      this.addStepNumber();
      this.goToRoute('myApartmentOne');
    },
    cancelRentAdRequest(apartmentId, adId) {
      (this as any).cancelError = '';
      const data = {apartmentId, adId};
      this.cancelRentAd(data)
          .then((response) => {
            if (response.status === 400 || response.status > 401 ) {
              (this as any).cancelError = response.data.mobile_errors[0].messages[0];
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    goToRoute(routeName) {
      this.$router.push({name: routeName, params: {id: this.apartmentData.id.toString()}});
    },
  },
  data() {
    return {
      cancelError: '',
    };
  },
})
export default class ApartmentTile extends Vue {}
